







import Vue from 'vue';
import Label from '../bases/Label/Label.vue';

export default Vue.extend({
  name: 'labelled-input',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  components: {
    Label,
  },
});
